import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import moment from 'moment-timezone'
import { Button, useErrorService, useUserService } from '@abroad/components'
import API from '../../utils/API'
import { openLinkInTab } from '../../utils/openLinkInTab'
import { surveyType } from '../../utils/constants'
import { sortedByDate } from '../../utils/date'

const AssessmentSelectionModal = ({
  isShowModal,
  onClose,
  showMaybeLater = false,
}) => {
  const [isLoadingProsperity, setIsLoadingProsperity] = useState(false)
  const [isLoadingAwareness, setIsLoadingAwareness] = useState(false)
  const Error = useErrorService()
  const history = useHistory()
  const { user } = useUserService()

  const getUrl = async (type) => {
    try {
      if (type === surveyType.PROSPERITY && user?.prosperityTaken) {
        setIsLoadingProsperity(true)
        const { data } = await API.survey.getSurveys(
          'personal',
          surveyType.PROSPERITY,
        )
        if (data?.surveys?.length > 0) {
          const latestSurvey = sortedByDate(data.surveys, 'createdAt')[0]
          const isWithin24Hours =
            moment().diff(moment(latestSurvey?.createdAt), 'days') < 1
          if (isWithin24Hours) {
            onClose()
            history.push(`/prosperity/${latestSurvey._id}`)
            setIsLoadingProsperity(false)
            return
          }
        }
      }
      if (type === surveyType.PROSPERITY) {
        setIsLoadingProsperity(true)
      } else {
        setIsLoadingAwareness(true)
      }
      const { data } = await API.survey.getLink(type)
      if (type === surveyType.PROSPERITY) {
        setIsLoadingProsperity(false)
      } else {
        setIsLoadingAwareness(false)
      }
      if (data?.code === 'upgrade_plan') {
        Error.showError(data)
      } else {
        openLinkInTab(data?.link, '_self')
      }
      onClose()
    } catch (e) {
      Error.showError(e)
      if (type === surveyType.PROSPERITY) {
        setIsLoadingProsperity(false)
      } else {
        setIsLoadingAwareness(false)
      }
    }
  }

  return (
    <Modal
      show={isShowModal}
      onHide={onClose}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog  justify-content-center'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          ASSESSMENT SELECTION
        </h3>
      </Modal.Header>
      <Modal.Body>
        <div className='s7 text-start'>
          As an Abroad Experience participant, we recommend taking the True
          Prosperity Assessment. Unlike the Awareness Assessment, which focuses
          on your work experience, True Prosperity offers a broader view of your
          overall life.
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-center flex-row pt-0'>
        <Button
          variant='saffron'
          className='text-uppercase'
          size='sm'
          disabled={isLoadingProsperity || isLoadingAwareness}
          // isLoading={isLoadingProsperity}
          onClick={() => getUrl(surveyType.PROSPERITY)}>
          Take the True Prosperity Assessment
        </Button>
        <Button
          variant='secondary-light'
          className='custom-padding text-uppercase secondary-popup-button'
          size='sm'
          disabled={isLoadingProsperity || isLoadingAwareness}
          // isLoading={isLoadingAwareness}
          onClick={() =>
            showMaybeLater ? onClose() : getUrl(surveyType.AWARENESS)
          }>
          {showMaybeLater
            ? 'Maybe Later'
            : 'Continue with Awareness Assessment'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AssessmentSelectionModal
